<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />
    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-table-solicitud-transferencias"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :pinnedBottomRowData="pinnedBottomRowData"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import moment from 'moment';
import listadoSolicitudRecursosMixin from '../mixins/listado-solicitud-recursos-mixin';
import { formatearValorAMoneda, obtenerColorEstadoDetalleSolicitud, TIPOS_SOLICITUD } from '../utils';

export default {
  name: 'ListadoSolicitudTransferencias',
  mixins: [listadoSolicitudRecursosMixin],
  data() {
    return {
      columnaTipoSolicitud: {
        headerName: 'TIPO',
        cellRenderer: function (param) {
          if (param.node.rowPinned) {
            return undefined;
          } else {
            return /*html */ `<span style="color: ${param.data.tipo == TIPOS_SOLICITUD.RECURSOS ? 'blue' : 'green'}">
              ${param.data.tipo == TIPOS_SOLICITUD.RECURSOS ? 'SEDES' : 'NACIONAL'}
            </span>`;
          }
        },
        filter: false,
        minWidth: 100,
        maxWidth: 100,
      },
      columnaDetalle: {
        headerName: 'DETALLE',
        headerComponentParams: {
          template: /* html*/ `
            <table width="100%" style="border-collapse">
                <tr>
                    <th style="font-size: 13px; font-weight: 600; width: 150px;">FECHA DESEMBOLSO</th>
                    <th style="font-size: 13px; font-weight: 600; width: 150px;">SEDE ORIGEN</th>
                    <th style="font-size: 13px; font-weight: 600; width: 150px;">BANCO ORIGEN</th>
                    <th style="font-size: 13px; font-weight: 600; width: 150px;">CUENTA ORIGEN</th>
                    <th style="font-size: 13px; font-weight: 600; width: 150px;">SEDE DESTINO</th>
                    <th style="font-size: 13px; font-weight: 600; width: 150px;">BANCO DESTINO</th>
                    <th style="font-size: 13px; font-weight: 600; width: 150px;">CUENTA DESTINO</th>
                    <th style="font-size: 13px; font-weight: 600; width: 275px;">DETALLE</th>
                    <th style="font-size: 13px; font-weight: 600; width: 275px;">CUENTA</th>
                    <th style="font-size: 13px; font-weight: 600; width: 275px;">CONTABLE</th>
                    <th style="font-size: 13px; font-weight: 600; width: 100px;">ESTADO</th>
                    <th style="font-size: 13px; font-weight: 600; width: 100px; text-align: right;">IMPORTE</th>
                </tr>
            </table>`,
        },
        cellRenderer: function (param) {
          if (param.node.rowPinned) {
            return undefined;
          } else {
            let detalle = /* html*/ `
            <table width="100%" style="border-collapse: collapse;">`;

            for (let index = 0; index < param.data.detalle_solicitud.length; index++) {
              const color = obtenerColorEstadoDetalleSolicitud(param.data.detalle_solicitud[index].estado);
              const fechaDesembolso = param.data.detalle_solicitud[index].fecha_desembolso
                ? moment(param.data.detalle_solicitud[index].fecha_desembolso).format('DD-MM-YYYY HH:mm:ss')
                : '-';

              detalle += /* html*/ `
                <tr>
                    <td style="width: 150px; max-width: 150px; overflow-x: hidden;">
                        ${fechaDesembolso}
                    </td>
                    <td style="width: 150px; max-width: 150px; overflow-x: hidden;">
                        ${param.data.detalle_solicitud[index].sede_origen}
                    </td>
                    <td style="width: 150px; max-width: 150px; overflow-x: hidden;">
                      ${param.data.detalle_solicitud[index].banco_origen}
                    </td>
                    <td style="width: 150px; max-width: 150px; overflow-x: hidden;">
                        ${param.data.detalle_solicitud[index].cuenta_origen}
                    </td>
                    <td style="width: 150px; max-width: 150px; overflow-x: hidden;">
                        ${param.data.detalle_solicitud[index].sede_destino}
                    </td>
                    <td style="width: 150px; max-width: 150px; overflow-x: hidden;">
                        ${param.data.detalle_solicitud[index].banco_destino}
                    </td>
                    <td style="width: 150px; max-width: 150px; overflow-x: hidden;">
                        ${param.data.detalle_solicitud[index].cuenta_destino}
                    </td>
                    <td style="width: 275px; max-width: 275px; overflow-x: hidden;">
                        ${param.data.detalle_solicitud[index].detalle}
                    </td>
                    <td style="width: 275px; max-width: 275px; overflow-x: hidden;">
                        ${param.data.detalle_solicitud[index].clasificador.codigo}
                        ${param.data.detalle_solicitud[index].clasificador.nombre}
                    </td>
                    <td style="width: 275px; max-width: 275px; overflow-x: hidden;">
                          ${
                            param.data.detalle_solicitud[index].clasificador.cuenta_contable
                              ? `${param.data.detalle_solicitud[index].clasificador.cuenta_contable.codigo}
                                ${param.data.detalle_solicitud[index].clasificador.cuenta_contable.nombre}`
                              : '-'
                          }
                    </td>
                    <td style="width: 100px; max-width: 100px; color: ${color};">
                      ${param.data.detalle_solicitud[index].estado}
                    </td>
                    <td style="width: 100px; max-width: 100px; text-align: right;">
                      ${formatearValorAMoneda(param.data.detalle_solicitud[index].importe)}
                    </td>
                </tr>`;
            }
            detalle += /* html*/ ` 
              <tr>
                  <td colspan="9" style="border-top: 1px solid #d9dcde;"></td>
                  <td style="border-top: 1px solid #d9dcde;"></td>
                  <td style="font-weight: 600; border-top: 1px solid #d9dcde;">TOTAL</td>
                  <td style="text-align: right; font-weight: 600; border-top: 1px solid #d9dcde;">
                    ${formatearValorAMoneda(
                      param.data.detalle_solicitud.reduce((a, b) => a + parseFloat(b.importe), 0),
                    )}
                  </td>
              </tr>
            </table>`;

            return detalle;
          }
        },
        valueGetter: function (param) {
          if (param.node.rowPinned) {
            return undefined;
          } else {
            let detalle = ``;
            for (let index = 0; index < param.data.detalle_solicitud.length; index++) {
              detalle += `
                ${param.data.detalle_solicitud[index].sede_origen}
                ${param.data.detalle_solicitud[index].cuenta_origen}
                ${param.data.detalle_solicitud[index].banco_origen}
                ${param.data.detalle_solicitud[index].cuenta_destino}
                ${param.data.detalle_solicitud[index].banco_destino}
                ${param.data.detalle_solicitud[index].detalle}
                ${param.data.detalle_solicitud[index].clasificador.nombre} ${param.data.detalle_solicitud[index].importe}`;
            }

            return detalle;
          }
        },
        autoHeight: true,
        suppressSizeToFit: true,
        filter: true,
        minWidth: 2075,
        maxWidth: 2075,
      },
    };
  },
  created() {
    this.columnDefs.splice(3, 0, this.columnaTipoSolicitud);
    this.columnDefs.splice(5, 0, this.columnaDetalle);
  },
};
</script>

<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';
@import './../css/styles.css';

.ag-grid-table-solicitud-transferencias {
  height: calc(var(--vh, 1vh) * 100 - 17.5rem);
}
</style>